var ModuleService = function() {
  this.completePages = function(model) {
    var self = model;
    model.activities.each(function(act) {
      act.pages.each(function(page) {
        if(!page.get('completed')) {
          page.set('completed', true);
          self.progress.save(page);
        }
      });
    });
  };

  this.markComplete = function(model) {
    model.progress.markComplete();
  };
};

module.exports = new ModuleService();